<script>
import axios from 'axios';
import utilsService from '@/api/utilsService';

const apiUrl = `${process.env.VUE_APP_API_URL}/api/taxonomias`;
const token = utilsService.getToken();

function buildQuery(key) {
  return `segmento=${encodeURIComponent(key.segmento)}` +
         `&familia=${encodeURIComponent(key.familia)}` +
         `&categoria=${encodeURIComponent(key.categoria)}` +
         `&clase=${encodeURIComponent(key.clase)}`;
}

function buildForm(formRaw) {
  return {
    segmento: formRaw.segmento,
    familia: formRaw.familia,
    categoria: formRaw.categoria,
    clase: formRaw.clase,
    version: formRaw.version,
    segmentoIngles: formRaw.segmentoIngles,
    familiaIngles: formRaw.familiaIngles,
    categoriaIngles: formRaw.categoriaIngles,
    claseIngles: formRaw.claseIngles,
    accion: formRaw.accion,
    actualizacion: formRaw.actualizacion,
  };
}

const taxonomiaService = {
  async getAll() {
    try {
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.data;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },

  async create(formRaw) {
    try {
      const form = buildForm(formRaw);

      const response = await axios.post(apiUrl, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response;
    } catch (error) {
      // Si viene de Axios, re-lanzar tal cual para conservar response.status y response.data
      if (error && error.response) {
        throw error;
      }
      throw {
        response: {
          status: 0,
          data: (error && error.message) ? error.message : 'Error en la solicitud.',
        },
      };
    }
  },

  async update(key, formRaw) {
    try {
      const form = buildForm(formRaw);

      const response = await axios.put(`${apiUrl}?${buildQuery(key)}`, form, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      if (error.response && error.response.data) {
        throw new Error(error.response.data || 'Error al actualizar la taxonomía.');
      } else {
        throw new Error(error.message || 'Error en la solicitud.');
      }
    }
  },

  async deleteBy(key) {
    try {
      const response = await axios.delete(`${apiUrl}?${buildQuery(key)}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      });
      return response.status;
    } catch (error) {
      throw new Error('Error fetching data: ' + error.message);
    }
  },
};

export default taxonomiaService;
</script>
